/* Passerelle Doctipro ↔ OphtaPilot : tout reste dans le navigateur (localStorage + BroadcastChannel), aucun envoi serveur. */
import { parsePatientColle } from './parsePatientColle';

const KEY_PATIENT = 'op_doctipro_patient';
const KEY_TEXTE = 'op_doctipro_texte';
const CANAL = 'ophtapilot-passerelle';

const lire = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch { return null; } };
const canal = () => (typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CANAL) : null);
const diffuser = (msg) => { const c = canal(); if (c) { c.postMessage(msg); c.close(); } };

export const lirePatientDoctipro = () => {
  const p = lire(KEY_PATIENT);
  if (!p?.texte) return null;
  // patient oublié après 12 h
  if (p.recu && Date.now() - new Date(p.recu).getTime() > 12 * 3600 * 1000) { localStorage.removeItem(KEY_PATIENT); return null; }
  return { ...p, infos: parsePatientColle(p.texte) };
};
export const enregistrerPatientDoctipro = (texte, source) => {
  localStorage.setItem(KEY_PATIENT, JSON.stringify({ texte, source: source || '', recu: new Date().toISOString() }));
  diffuser({ type: 'patient' });
};
export const effacerPatientDoctipro = () => { localStorage.removeItem(KEY_PATIENT); diffuser({ type: 'patient' }); };

export const lireTexteDoctipro = () => lire(KEY_TEXTE);
export const preparerTexteDoctipro = (texte, titre) => {
  localStorage.setItem(KEY_TEXTE, JSON.stringify({ texte, titre: titre || '', prepare: new Date().toISOString() }));
  diffuser({ type: 'texte' });
};

export const repondreAccuse = () => diffuser({ type: 'accuse' });

/** S'abonne aux changements (autres onglets inclus). Retourne la fonction de désabonnement. */
export const abonnerPasserelle = (cb) => {
  const c = canal();
  const onMsg = (e) => cb(e.data || {});
  const onStorage = (e) => { if (e.key === KEY_PATIENT || e.key === KEY_TEXTE) cb({ type: 'storage' }); };
  if (c) c.addEventListener('message', onMsg);
  window.addEventListener('storage', onStorage);
  return () => { if (c) { c.removeEventListener('message', onMsg); c.close(); } window.removeEventListener('storage', onStorage); };
};

/** Blocs d'un document Programmation → texte brut collable. */
export const blocsVersTexte = (blocks) => {
  const clean = (s) => String(s || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&#8211;/g, '–').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').trim();
  const out = [];
  for (const b of blocks || []) {
    const t = clean(b.text);
    if (!t) { if (b.type === 'spacer') out.push(''); continue; }
    if (b.type === 'li') out.push(`- ${t}`);
    else if (b.type === 'checkbox') out.push(`☐ ${t}`);
    else if (b.type === 'ttable' || b.type === 'cols2') out.push(t.split('\n').map(r => r.split('|').map(c => c.trim()).join('\t')).join('\n'));
    else out.push(t);
  }
  return out.join('\n').replace(/\n{3,}/g, '\n\n').trim();
};
